import { Pagination } from './common';
import { BaseCaseFilters } from './lawyerDirectory';
import { DataType } from './pdfFieldDetection';

export interface ClientDocumentsParams {
	page: string;
	limit: string;
	search: string;
	client_status: string;
	document_status: string;
	document_types: string;
	case_id: string;
	client_id: string;
	received_start_date: string;
	received_end_date: string;
	sent_start_date: string;
	sent_end_date: string;
}

export interface ClientDocumentsItems extends Pagination {
	items: ItemClientDocument[];
}

export interface ItemClientDocument {
	application_id: number;
	firstname: string;
	lastname: string;
	email: string;
	profile_picture: null;
	client_status: string;
	status_date: string;
	document_status: string;
	documents: ClientDocument[];
}

export interface ClientDocument {
	document_id: number;
	document_type: string;
	document_name: string;
	url: string | null;
	client_task_end_date: string | null;
	date_received: string;
	date_sent: string;
}

export type RequiredQuestionType =
	| 'TEXT'
	| 'EMAIL'
	| 'NUMBER'
	| 'PHONE'
	| 'ADDRESS'
	| 'YES_NO'
	| 'DATE';
export interface RequiredQuestions {
	question: string;
	type: RequiredQuestionType;
}

export interface SendDocumentPayload extends BaseCaseFilters {
	doc_url: string;
	is_signature_required: boolean;
	document_name: string;
	sign_date?: string;
	case_id: string;
	users_ids: string[];
	required_questions: {
		field_name: string;
		question: string;
		type: DataType;
	}[];
	email_text?: string;
	hideSigningDate: boolean;
}

export interface RequestDocumentToClientsPayload extends BaseCaseFilters {
	document_name: string;
	skip_document: boolean;
	case_id: string;
	users_ids: string[];
	email_text: string | undefined;
	criteria: RequestDocumentItem[];
}

export interface RequestDownload {
	folderZipName: string;
	documents: DocumentsToDownload[];
}

export interface DocumentsToDownload {
	docUrl: string;
	nameDoc: string;
}

export interface DownloadDocumentsParams {
	select_all: boolean;
	client_status?: string[];
	document_status?: string[];
	document_types?: string[];
	clients_document?: IClientDocuments[];
}

export interface IClientDocuments {
	application_id: number;
	docs: ItemDocument[];
}

export interface ItemDocument {
	document_id: number;
	document_type: string;
}

export interface RequestDocumentData {
	document_name: string;
	skip_document: boolean;
	request_question: RequestDocumentItem[];
	message?: string;
}

export interface RequestDocumentPayload {
	criteria: RequestDocumentItem[];
}

export const RequestDocumentItemMap: Record<string, string> = {
	CLIENT_NAME: 'client name',
	PHONE_NUMBER: 'phone number',
	ADDRESS: 'address',
	EMAIL: 'email',
	PROMPT: 'prompt',
};

export type criteriaType = keyof typeof RequestDocumentItemMap;

export interface RequestDocumentItem {
	is_required: boolean;
	criteria_type: criteriaType;
	prompt?: string;
}

export interface RejectClient extends BaseCaseFilters {
	caseId: string;
	users_ids: string[];
	rejected: boolean;
}

export interface BulkFlagClient extends BaseCaseFilters {
	caseId: string;
	users_ids: string[];
	reasons: string[];
	flagged: boolean;
}

export interface FlagReasonsCountRequest extends BaseCaseFilters {
	caseId: string;
	users_ids: string[];
}

export interface BulkRejectClients extends BaseCaseFilters {
	caseId: string;
	application_ids: number[];
}
